import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setOaName, setPublic, setDate, setType, getOas, setPos, getFilterOptions, getActivitiesOptions } from '../../actions';
import { userType } from '../../utils/mockups';

import ptLocale from 'moment/locale/pt-br';
import moment from 'moment';
import { Link } from "react-router-dom";
import InputSelect from "../Input/Input";
import CalendarIcon from "../../assets/calendar-icon.svg";

import { DateRangePicker } from 'react-dates';

import './Filters.scss';

moment.updateLocale('pt-br', ptLocale);


class Filters extends Component {
  state = {
    userType: [],
    startDate: null,
    endDate: null,
    activityDate: [],
    focusedInput: null,

  }
  componentDidMount() {
    this.props.getActivitiesOptions()
    this.props.getFilterOptions()
    this.setState({
      userType,
      startDate: this.props.oaStartDate ? moment(this.props.oaStartDate) : null,
      endDate: this.props.oaEndDate ? moment(this.props.oaEndDate) : null,
    })

  }
  handleChangeDates(startDate, endDate) {    
    this.setState({ startDate, endDate })
    this.props.setDate(startDate , endDate)
  }

  render() {

    const { setOaName, setPublic, setType, getOas } = this.props;
    return (
      <section className="filters-group">
        <InputSelect
          onChange={(val) => setOaName(val[Object.keys(val)[0]])}
          options={this.props.options}
          creatable placeholder="Pesquise por Cidade, Estado, CEP ou Nome do O.A"
          name="oaName"
          className="big"
          icon="searchIcon"
        />
        <InputSelect
          onChange={(val) => setPublic([val])}
          options={userType}
          name="userType"
          placeholder="Escolha o Público"
          icon="publicIcon"
          className="big"
        />
        <InputSelect
          onChange={(val) => setType([val])}
          options={this.props.activitiesOptions}
          name="activityType"
          placeholder="Escolha a Atividade"
          icon="activityIcon"
          className="big"
        />

        <DateRangePicker
          readOnly={true}
          startDate={this.state.startDate}
          startDateId="start_date"
          endDate={this.state.endDate}
          endDateId="end_date"
          onDatesChange={({ startDate, endDate }) => this.handleChangeDates(startDate, endDate)}
          focusedInput={this.state.focusedInput}
          onFocusChange={focusedInput => this.setState({ focusedInput })}
          orientation={`${window.innerWidth > 768 ? 'horizontal' : 'vertical'}`}
          startDatePlaceholderText="De data"
          endDatePlaceholderText="Até data"
          customInputIcon={<img src={CalendarIcon} alt="Selecione uma data"
          />}
        />
        <Link to={'/oa'} className="search-button">
          <button className="btn btn-primary big-button"
            onClick={() => getOas()}
            style={{ marginTop: "1rem" }}
          >
            PESQUISAR
          </button>
        </Link>
      </section>
    );
  }
}
const mapStateToProps = store => ({
  oaName: store.filterState.oaName,
  publicType: store.filterState.publicType,
  activityType: store.filterState.activityType,
  activityDate: store.filterState.activityDate,
  oaStartDate: store.filterState.oaStartDate,
  oaEndDate: store.filterState.oaEndDate,
  options: store.filterState.options,
  activitiesOptions: store.filterState.activitiesOptions
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ setOaName, setPublic, setDate, setType, getOas, setPos, getFilterOptions, getActivitiesOptions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Filters);